export default __webpack_public_path__ + "static/signup-modal-horizontal-39dcaef9e9ef996429c08c12a5d42efa.jpg";